export default "__VITE_ASSET__DXd2JaW3__"